<template>
  <span :class="rootClass">
    {{ pointsCount }}
  </span>
</template>

<script>
export default {
  name: 'HeaderCommissionBalanceBadge',
  props: {
    count: {
      type: Number,
      default: null,
      required: true,
    },
  },
  computed: {
    pointsCount() {
      return this.count > 0 ? `+${this.count}` : `-${Math.abs(this.count)}`;
    },
    rootClass() {
      return {
        'header-commission-balance-badge': true,
        'header-commission-balance-badge--negative': this.count < 0,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.header-commission-balance-badge {
  @include subhead-semibold;

  line-height: 20px;
  padding: 0 4px;
  background: $next-primary;
  border-radius: 6px;
  color: var(--universal-color-white);

  &--negative {
    background: $next-red;
  }
}
</style>
